/* AS Povljana - reveal-on-scroll for landing sections.
   Guarded so it is safe to include the tag in every section. */
(function () {
  if (window.__asLandingInit) return;
  window.__asLandingInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function run(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('.as-reveal:not(.as-in)');
    if (!els.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('as-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('as-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14 });

    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(document); });
  } else {
    run(document);
  }

  /* Re-run when the theme editor re-renders a section */
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
